// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oIhID","col":"styles_col__322dW"};